'use client';

// next-intl's usePathname is locale-stripped. next/navigation's would make `pathSegments[0]`
// 'en-US' on a prefixed path, so neither the 'inspiration' nor 'destination' branch below matches
// and the `source` param is silently dropped — losing LP source attribution for en-US visitors.
import { usePathname } from '~/i18n/navigation';
import { Link } from './Link';
import type { LinkProps } from './Link.types';

const appendLPSourceToUrl = (sourceUrl: string, destinationUrl: string) => {
  // Get the first part of the path (after initial slash)
  const pathSegments = sourceUrl.split('/').filter(Boolean);
  const firstPathSegment = pathSegments[0];
  // Set source based on first path segment
  let source = '';
  if (firstPathSegment === 'inspiration') {
    source = 'blueprintCollection';
  } else if (firstPathSegment === 'destination') {
    source = 'blueprintDestination';
  } else {
    return destinationUrl;
  }

  // Add src parameter
  const separator = destinationUrl.includes('?') ? '&' : '?';
  return `${destinationUrl}${source ? `${separator}source=${source}` : ''}`;
};

const LinkWithSource = ({ href, children, ...props }: LinkProps) => {
  const pathname = usePathname() || '';
  const urlWithSource = appendLPSourceToUrl(pathname, href);
  return (
    <Link href={urlWithSource} {...props}>
      {children}
    </Link>
  );
};

export { LinkWithSource, appendLPSourceToUrl };
